"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _callback = _interopRequireDefault(require("use-debounce/lib/callback"));

var _pipe = _interopRequireDefault(require("unmutable/pipe"));

var _dataparcels = _interopRequireDefault(require("dataparcels"));

var _asRaw = _interopRequireDefault(require("dataparcels/asRaw"));

var _setMeta = _interopRequireDefault(require("dataparcels/lib/parcelData/setMeta"));

var _ApplyBeforeChange = _interopRequireDefault(require("./util/ApplyBeforeChange"));

var _ParcelBoundaryEquals = _interopRequireDefault(require("./util/ParcelBoundaryEquals"));

var _pipeWithFakePrevParcel = _interopRequireDefault(require("./util/pipeWithFakePrevParcel"));

var _useParcelBufferInternalBuffer = _interopRequireDefault(require("./useParcelBufferInternalBuffer"));

var _useParcelBufferInternalKeepValue = _interopRequireDefault(require("./useParcelBufferInternalKeepValue"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var _default = function _default(params) {
  var parcelRef = (0, _react.useRef)();
  parcelRef.current = params.parcel;
  var applyBeforeChange = (0, _ApplyBeforeChange["default"])(params.beforeChange); //
  // parcel state and change logic
  //
  // outerParcel is locked to changes in props

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      outerParcel = _useState2[0],
      setOuterParcel = _useState2[1]; // innerParcel can deviate from props


  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      innerParcel = _useState4[0],
      setInnerParcel = _useState4[1]; // shouldKeepValue


  var shouldKeepValue = (0, _useParcelBufferInternalKeepValue["default"])(params); //
  // inner parcel prep
  //
  // 1. always apply applyBeforeChange to inner parcel
  //    so changes to innerParcel go up through beforeChange functions
  // 2. always add and set buffer meta to be passed to innerParcel

  var applyBufferMeta = function applyBufferMeta(parcel) {
    return parcel.modifyDown((0, _asRaw["default"])((0, _setMeta["default"])({
      _submit: false,
      _reset: false
    })));
  };

  var applyModifiers = (0, _pipe["default"])(applyBeforeChange, applyBufferMeta);

  var prepareKeepValue = function prepareKeepValue(parcel) {
    // set existing value and child on the new parcel from props
    var data = _objectSpread({}, parcel.data, {
      value: innerParcel.value,
      child: innerParcel.child
    });

    var _parcel$_changeAndRet = parcel._changeAndReturn(function (parcel) {
      return parcel._setData(data);
    }),
        _parcel$_changeAndRet2 = (0, _slicedToArray2["default"])(_parcel$_changeAndRet, 1),
        changedParcel = _parcel$_changeAndRet2[0];

    return changedParcel;
  };

  var prepareInnerParcelFromOuter = function prepareInnerParcelFromOuter() {
    // if keepValue is used, beforeChange is ignored
    if (params.keepValue) {
      return shouldKeepValue ? prepareKeepValue : function (parcel) {
        return parcel;
      };
    }

    return (0, _pipeWithFakePrevParcel["default"])(outerParcel, applyBeforeChange); // ^ this runs a parcel through beforeChange immediately
    // shoving outerParcel in as a fake previous value
  }; //
  // buffer ref and functions
  //


  var internalBuffer = (0, _useParcelBufferInternalBuffer["default"])({
    onReset: function onReset() {
      return setOuterParcel(null);
    },
    // ^ resets by recreating innerParcel from outerParcel
    onSubmit: function onSubmit(changeRequest) {
      changeRequest._revertCallback = function (changeRequest) {
        internalBuffer.unshift(changeRequest);
      };

      parcelRef.current.dispatch(changeRequest);
    } // ^ submits by dispatching the buffered change request

  }); //
  // debounce
  //

  var _useDebouncedCallback = (0, _callback["default"])(internalBuffer.submit, params.debounce),
      _useDebouncedCallback2 = (0, _slicedToArray2["default"])(_useDebouncedCallback, 3),
      debounceRelease = _useDebouncedCallback2[0],

  /* blank */
  callDebounceRelease = _useDebouncedCallback2[2];

  if (!params.debounce) {
    callDebounceRelease();
  } //
  // update inner parcel when outer parcel changes (or is first set)
  //


  var newInnerParcel;

  if (!outerParcel || !(0, _ParcelBoundaryEquals["default"])(params.parcel, outerParcel)) {
    var handleChange = function handleChange(newParcel, changeRequest) {
      var debounce = params.debounce,
          _params$buffer = params.buffer,
          buffer = _params$buffer === void 0 ? true : _params$buffer,
          keepValue = params.keepValue; // remember the origin of the last change
      // useParcelBufferInternalKeepValue needs it

      newParcel._frameMeta.lastOriginId = changeRequest.originId; // remove buffer actions meta from change request
      // and push any remaining change into the buffer

      var actions = changeRequest._actions.filter(function (action) {
        return !(action.type === 'setMeta' && (action.payload._submit || action.payload._reset));
      });

      if (actions.length > 0) {
        internalBuffer.push(changeRequest._create({
          actions: actions
        }));
      }

      if (buffer || debounce) {
        // if buffer is to be used, update inner parcel immediately
        // and request a debounced submit if debounce is set
        setInnerParcel(newParcel.pipe(applyModifiers));
        debounce && debounceRelease();
      } else {
        // if no buffer, just propagate it immediately
        internalBuffer.submit(); // if keepValue is true, the buffer is in change of its own state
        // rather than waiting for new props containing the new value

        keepValue && setInnerParcel(newParcel.pipe(applyModifiers));
      } // trigger buffer actions if meta says so


      var _newParcel$meta = newParcel.meta,
          _submit = _newParcel$meta._submit,
          _reset = _newParcel$meta._reset;
      _submit && internalBuffer.submit();
      _reset && internalBuffer.reset();
    };

    var newOuterParcel = params.parcel;
    setOuterParcel(newOuterParcel); // clear buffer if it exists and if we aren't rebasing

    if (internalBuffer.bufferState && !newOuterParcel._frameMeta.rebase) {
      internalBuffer.reset();
    } // boundary split to ensure that inner parcels chain are
    // completely isolated from outer parcels chain


    newInnerParcel = params.parcel._boundarySplit({
      handleChange: handleChange
    }).pipe(prepareInnerParcelFromOuter())._changeAndReturn(function (parcel) {
      // apply buffered changes to new parcel from props
      var changeRequest = internalBuffer.bufferState;
      changeRequest && parcel.dispatch(changeRequest);
    })[0].pipe(applyModifiers);
    setInnerParcel(newInnerParcel);
  }

  var returnedParcel = innerParcel || newInnerParcel; //
  // parcel buffer control
  //

  var actions = internalBuffer.bufferState ? internalBuffer.bufferState.actions : [];
  var parcelControl = {
    submit: function submit() {
      return returnedParcel.setMeta({
        _submit: true
      });
    },
    reset: function reset() {
      return returnedParcel.setMeta({
        _reset: true
      });
    },
    buffered: actions.length > 0,
    actions: actions,
    _outerParcel: params.parcel
  }; //
  // return
  //

  return [returnedParcel, parcelControl];
};

exports["default"] = _default;